var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('dhcp-server-list',{attrs:{"campusSlug":_vm.campusSlug,"canChangeCampus":_vm.canChangeCampus,"fixedNetworkCampus":_vm.fixedNetworkCampus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }